import React from "react";
import { Polygon, Pane } from "react-leaflet";
import { connect } from "react-redux";

class WindTurbineFlowArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { windTurbineFlowAreaPolygonPoints, isWindTurbineFlowAreaVisible } =
      this.props.rasterArea;

    if (
      !windTurbineFlowAreaPolygonPoints ||
      !isWindTurbineFlowAreaVisible ||
      this.props.rasterArea.currentCase?.applicationField !== 5
    ) {
      return null;
    }



    // Convert polygon points to Leaflet format [lat, lng]
    const positions = windTurbineFlowAreaPolygonPoints.map((point) => [
      point[0],
      point[1],
    ]);

    return (
      <Pane className="wind-turbine-flow-area" style={{ zIndex: 400 }}>
        <Polygon positions={positions}
          color="#ef6565ff"
          fill={false}
          lineJoin={"round"}
          weight={6}
          dashArray="20"
        />
      </Pane>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    rasterArea: state.rasterArea,
    crsDef: state.map.crsDef,
  };
};

export default connect(mapStateToProps, null)(WindTurbineFlowArea);

